import React from 'react';
import { Card } from '../../../components/base/Card';

export const AboutSection: React.FC = () => {
  return (
    <section id="quienes-somos" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-primary-800 mb-6">
            Quiénes Somos
          </h2>
          <div className="w-24 h-1 bg-primary-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
            <strong className="text-primary-700">BiviLinks</strong> es una plataforma digital que conecta personas con proveedores de servicios y productos de uso cotidiano.
          </p>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto mt-4">
            A través de un sistema de referidos, cualquier usuario puede ganar dinero al compartir su enlace personal con otros.
          </p>
        </div>

        <div className="mb-16">
          <h3 className="text-2xl md:text-3xl font-bold text-center text-primary-700 mb-12">
            Somos el puente entre:
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <Card className="text-center p-8 hover:shadow-2xl transition-all duration-300 border-t-4 border-primary-600">
              <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-user-search-line text-4xl text-primary-600"></i>
              </div>
              <h4 className="text-xl font-semibold text-primary-800 mb-4">Personas que necesitan soluciones</h4>
              <p className="text-gray-600">
                Usuarios buscando servicios y productos confiables para su día a día.
              </p>
            </Card>

            <Card className="text-center p-8 hover:shadow-2xl transition-all duration-300 border-t-4 border-primary-600">
              <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-store-line text-4xl text-primary-600"></i>
              </div>
              <h4 className="text-xl font-semibold text-primary-800 mb-4">Quienes ofrecen servicios o productos</h4>
              <p className="text-gray-600">
                Proveedores, negocios y profesionales listos para atender necesidades.
              </p>
            </Card>

            <Card className="text-center p-8 hover:shadow-2xl transition-all duration-300 border-t-4 border-primary-600">
              <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-links-line text-4xl text-primary-600"></i>
              </div>
              <h4 className="text-xl font-semibold text-primary-800 mb-4">Aquellos que hacen que ambos se encuentren</h4>
              <p className="text-gray-600">
                Referidores que conectan y ganan por cada vínculo exitoso.
              </p>
            </Card>
          </div>
        </div>

        <div className="bg-primary-600 rounded-2xl p-12 text-center shadow-2xl">
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Sin ventas. Sin reclutas. Sin inversión.
          </h3>
          <p className="text-2xl text-white font-semibold">
            Solo conectas.
          </p>
        </div>
      </div>
    </section>
  );
};
